import script from "./LockMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./LockMessage.vue?vue&type=script&setup=true&lang=js"

import "./LockMessage.vue?vue&type=style&index=0&id=7c1647ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c1647ba"]])

export default __exports__